/** Привязка Telegram к учётке — `GET/POST /api/tg/link`. */
import { apiFetch } from "@/lib/api";

export type TgLink = {
  linked: boolean;
  tg_username: string;
  tg_name: string;
  date_link: string | null;
  bot: string;
};

export type TgLinkUrl = { url: string; expire: string };

export const loadTgLink = () => apiFetch<TgLink>("/api/tg/link");
export const newTgLink = () => apiFetch<TgLinkUrl>("/api/tg/link", { method: "POST" });
